import { createContext, useContext } from 'react';
import type { StockAppearance } from 'types/product';

/** Apariencia sin guardar que usan las vistas previas del admin en lugar de la publicada. */
export const StockAppearancePreviewContext = createContext<StockAppearance | null>(null);

export const useStockAppearancePreview = () => useContext(StockAppearancePreviewContext);
